<template>
  <div class="screen">
    <h2>{{ headline }}</h2>

    <div class="scores">
      <div
        v-for="(entry, index) in standings"
        :key="entry.id"
        class="score-row score-row--enter"
        :style="{ animationDelay: `${index * 120}ms` }"
        :class="{ 'score-row--winner': entry.isWinner }"
      >
        <span class="score-row__rank">{{ index + 1 }}</span>
        <span class="score-row__name">{{ entry.name }}</span>
        <span class="score-row__total">{{ entry.claimed.length }}</span>
        <span class="score-row__detail">{{ detailFor(entry) }}</span>
      </div>
    </div>

    <template v-if="!isOnline">
      <button class="primary" @click="playAgain">Play again</button>
      <button class="secondary" @click="backToMenu">Back to menu</button>
    </template>
    <template v-else>
      <button class="primary" @click="leaveOnline">Leave game</button>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

// The final standings. Lighter than no-thanks's staged reveal on purpose:
// there, the scores were secret until counted; here everyone WATCHED the
// winning column get banked seconds ago, so the screen's job is to confirm
// it and offer the next game, not to build suspense the board already spent.
// The row-stagger animation keeps a little of the arrival without holding
// anything back.
export default {
  name: 'ScoreSheet',
  computed: {
    ...mapGetters(['standings', 'isOnline']),
    headline() {
      const winner = this.standings.find((e) => e.isWinner);
      if (!winner) return 'Game over';
      const mine = this.isOnline
        ? winner.id === this.$store.getters.myUid
        : winner.id === 'you';
      return mine ? 'You win!' : `${winner.name} wins`;
    },
  },
  methods: {
    detailFor(entry) {
      if (entry.claimed.length === 0) return 'no columns claimed';
      const columns = [...entry.claimed].sort((a, b) => a - b).join(', ');
      return `claimed ${columns}`;
    },
    playAgain() {
      this.$store.dispatch('newGame');
    },
    backToMenu() {
      this.$store.dispatch('abandonGame');
    },
    leaveOnline() {
      this.$store.dispatch('leaveRoom');
    },
  },
};
</script>
